<!DOCTYPE html>
<html class="html">
<body>
<app-topbar></app-topbar>
<app-topmenu></app-topmenu>
<router-outlet></router-outlet>
<app-footer></app-footer>
</body>
</html>